import { createSelector } from '@ngrx/store';
import { createFilterStateSelector } from '../create-filter-state-selector/create-filter-state.selector';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createFieldStateSelector = (filterInstanceId: string, fieldId: string) =>
  createSelector(createFilterStateSelector(filterInstanceId), (filterState) => {
    if (filterState?.fieldsState) {
      return filterState.fieldsState[fieldId];
    }
  });
